import { StrictMode } from "react";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "@store/index";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import ErrorBoundary from "@utils/ErrorBoundary";
import App from "@/App";
import { FacebookProvider } from "@components/MetaConnections/FacebookProvider";
import Loader from "@UI/Loader/Loader";
import "@/i18n";
import "@/index.css";

/**
 * Application Entry Point
 *
 * Sets up the React application with:
 * - Redux store and persistence
 * - Error boundary for error handling
 * - Facebook provider for social integrations
 * - Internationalization support
 * Routing is handled inside App (BrowserRouter).
 */

const root = ReactDOM.createRoot(document.getElementById("root"));

const LoadingFallback = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      backgroundColor: "var(--color-bg-primary)",
    }}
  >
    <Loader />
  </div>
);

root.render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate loading={<LoadingFallback />} persistor={persistor}>
        <ErrorBoundary>
          <FacebookProvider>
            <App />
          </FacebookProvider>
        </ErrorBoundary>
      </PersistGate>
    </Provider>
  </StrictMode>
);
